<!-- <div class="app-page-title" style="background: linear-gradient(to left, #1271b2, #ff6e33)">
  <div class="page-title-wrapper">
    <div class="page-title-heading" >
      
       <img src=".\assets\images\d1.png" alt="img1" style="width:50px;">
      
      <div> <span class="h3 fw-bold text-white mx-2">Dashboard</span>
      </div>
    </div>
    <div class="page-title-actions">
      <button type="button"
        class="btn-shadow d-inline-flex align-items-center btn fw-bold text-white" (click)="renewal()" style="background-color:#ff6d33d6"> Renewal </button></div>
  </div>
</div>
<div class="mb-3 card">
  <div class="card-header-tab card-header" style="background: linear-gradient(to right, #1271b2, #ff6e33);">
    <div class="card-header-title font-size-lg text-capitalize fw-bold">
      <i class="header-icon lnr-charts icon-gradient bg-happy-green"> </i>
     <span class="fw-bold text-white">Portfolio Performance</span> 
    </div>
  </div>
  <div class="g-0 row">
    <div class="col-sm-6 col-md-4 col-xl-4" >
      <div class="card no-shadow rm-border widget-chart text-start" style="background: linear-gradient(to left, #1271b2, #ff6e33);border-radius:1px;" >
        <div class="icon-wrapper rounded-circle" >
          <div class="icon-wrapper-bg opacity-10 " style="background-color:coral;"></div>
          <i class="pe-7s-ribbon text-white opacity-8"></i>
        </div>
        <div class="widget-chart-content">
          <div class="widget-subheading text-white" >Plan</div>
          <div class="widget-numbers text-white" >299</div>
        </div>
      </div>
      <div class="divider m-0 d-md-none d-sm-block"></div>
    </div>
    <div class="col-sm-6 col-md-4 col-xl-4">
      <div class="card no-shadow rm-border  widget-chart text-start" style="background: linear-gradient(to left, #1271b2, #ff6e33);border-radius:1px;">
        <div class="icon-wrapper rounded-circle">
          <div class="icon-wrapper-bg opacity-9 " style="background-color:coral;"></div>
          <i class="pe-7s-graph2 text-white"></i>
        </div>
        <div class="widget-chart-content">
          <div class="widget-subheading text-white" >Usage Data</div>
          <div class="widget-numbers text-white"><span>5.5GB </span></div>
        </div>
      </div>
      <div class="divider m-0 d-md-none d-sm-block"></div>
    </div>
    <div class="col-sm-12 col-md-4 col-xl-4">
      <div class="card no-shadow rm-border  widget-chart text-start" style="background: linear-gradient(to left, #1271b2, #ff6e33);border-radius:1px;">
        <div class="icon-wrapper rounded-circle">
          <div class="icon-wrapper-bg opacity-10" style="background-color:coral;"></div>
          <i class="pe-7s-date text-white"></i>
        </div>
        <div class="widget-chart-content">
          <div class="widget-subheading text-white">Remaining No of Days</div>
          <div class="widget-numbers text-white ">63</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-12 col-lg-6">
    <div class="row">
      <div class="col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 text-start card-btm-border card-shadow-success" style="background: linear-gradient(to left, #1271b2, #ff6e33);">
          <div class="widget-chat-wrapper-outer">
            <div class="widget-chart-content pt-3 ps-3 pb-1">
              <div class="widget-chart-flex">
                <div class="widget-numbers">
                  <div class="widget-chart-flex">
                    <div class="fsize-4">
                      <small class="opacity-6 text-white">₹</small>
                      <span class="text-white">874</span>
                    </div>
                  </div>
                </div>
              </div>
              <h6 class="widget-subheading mb-0 opacity-8 text-white " >Plan</h6>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 text-start card-btm-border card-shadow-primary " style="background: linear-gradient(to left, #1271b2, #ff6e33);">
          <div class="widget-chat-wrapper-outer">
            <div class="widget-chart-content pt-3 ps-3 pb-1">
              <div class="widget-chart-flex">
                <div class="widget-numbers">
                  <div class="widget-chart-flex">
                    <div class="fsize-4">
                      <span class="text-white fw-bold">Unlimited</span>
                    </div>
                  </div>
                </div>
              </div>
              <h6 class="widget-subheading mb-0 opacity-8 text-white">Total Data</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 text-start card-btm-border card-shadow-warning " style="background: linear-gradient(to right, #1271b2, #ff6e33);">
          <div class="widget-chat-wrapper-outer">
            <div class="widget-chart-content pt-3 ps-3 pb-1">
              <div class="widget-chart-flex">
                <div class="widget-numbers">
                  <div class="widget-chart-flex">
                    <div class="fsize-4">
                      <span class="text-white fw-bold">100Mbps</span>
                    </div>
                  </div>
                </div>
              </div>
              <h6 class="widget-subheading mb-0 opacity-7 text-white">Miximum Upload Bandwidth</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 text-start card-btm-border card-shadow-danger" style="background: linear-gradient(to right, #1271b2, #ff6e33);">
          <div class="widget-chat-wrapper-outer">
            <div class="widget-chart-content pt-3 ps-3 pb-1">
              <div class="widget-chart-flex">
                <div class="widget-numbers">
                  <div class="widget-chart-flex">
                    <div class="fsize-4">
                      <span class="text-white fw-bold">100Mbps</span>
                    </div>
                  </div>
                </div>
              </div>
              <h6 class="widget-subheading mb-0 opacity-7 text-white">Miximum Download Bandwidth</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 text-start card-btm-border card-shadow-info" style="background: linear-gradient(to left, #1271b2, #ff6e33);">
          <div class="widget-chat-wrapper-outer">
            <div class="widget-chart-content pt-3 ps-3 pb-1">
              <div class="widget-chart-flex">
                <div class="widget-numbers">
                  <div class="widget-chart-flex">
                    <div class="fsize-4">
                      <span class="text-white fw-bold">80</span>
                    </div>
                  </div>
                </div>
              </div>
              <h6 class="widget-subheading mb-0 opacity-7 text-white">Total Days</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 text-start card-btm-border card-shadow-warning " style="background: linear-gradient(to left, #1271b2, #ff6e33);">
          <div class="widget-chat-wrapper-outer">
            <div class="widget-chart-content pt-3 ps-3 pb-1">
              <div class="widget-chart-flex">
                <div class="widget-numbers">
                  <div class="widget-chart-flex">
                    <div class="fsize-4">
                      <span class="text-white fw-bold">26/06/2026</span>
                    </div>
                  </div>
                </div>
              </div>
              <h6 class="widget-subheading mb-0 opacity-7 text-white">Plan Expired Date</h6>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  
  <div class="col-sm-12 col-lg-6 ">
    <div class="card-hover-shadow-2x mb-3 card">
      <div class="card-header-tab card-header"  style="background: linear-gradient(to left, #1271b2, #ff6e33);">
        <div class="card-header-title font-size-lg text-capitalize fw-normal">
          <i class="header-icon lnr-lighter icon-gradient bg-amy-crisp"> </i>
          <span class="fw-bold text-white">Recharge History</span>
        </div>
      </div>
      <div class="scroll-area-lg">
        <perfect-scrollbar [autoPropagation]="true">
          <div class="p-4" style="background: linear-gradient(to left, #1271b2, #ff6e33);">
            <div
              class="vertical-time-simple vertical-without-time vertical-timeline--animate vertical-timeline--one-column">

              <div class="dot-primary vertical-timeline-element border-white border-2">
                <div style="display: flex;" >
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg opacity-9 " style="background-color:coral;"></div>
                    <i class="pe-7s-date text-white"></i>
                  </div>
                  <div style="width: 100%;">
                    <div style="display: flex;justify-content: space-between;">
                      <div class="vertical-timeline-element-content bounce-in" style="margin-left: 15px;">
                        <h6 class="timeline-title text-white">
                          Recharge for Prepaid
                        </h6>
                        <h4 class="timeline-title text-white">
                          99XXXXXX56
                        </h4>
                      </div>
                      <span class="text-white">299</span>
                    </div>
                    <div style="display: flex;justify-content: space-between;">
                      <p style="margin-left: 15px;margin-top: 0; " class="text-white">16 Feb, <span class="text-white">15:00 PM</span></p>
                      <span class="text-white">Debit Card</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dot-primary vertical-timeline-element border-white border-2">
                <div style="display: flex;">
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg opacity-9 " style="background-color:coral;"></div>
                    <i class="pe-7s-date text-white"></i>
                  </div>
                  <div style="width: 100%;">
                    <div style="display: flex;justify-content: space-between;">
                      <div class="vertical-timeline-element-content bounce-in" style="margin-left: 15px;">
                        <h6 class="timeline-title text-white">
                          Recharge for Prepaid
                        </h6>
                        <h4 class="timeline-title text-white">
                          99XXXXXX56
                        </h4>
                      </div>
                      <span class="text-white">299</span>
                    </div>
                    <div style="display: flex;justify-content: space-between;">
                      <p style="margin-left: 15px;margin-top: 0;"class="text-white">16 Feb, <span class="text-white">15:00 PM</span></p>
                      <span class="text-white">Debit Card</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dot-primary vertical-timeline-element border-white border-2">
                <div style="display: flex;">
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg opacity-9 "  style="background-color:coral;"></div>
                    <i class="pe-7s-date text-white"></i>
                  </div>
                  <div style="width: 100%;">
                    <div style="display: flex;justify-content: space-between;">
                      <div class="vertical-timeline-element-content bounce-in" style="margin-left: 15px;">
                        <h6 class="timeline-title text-white">
                          Recharge for Prepaid
                        </h6>
                        <h4 class="timeline-title text-white">
                          99XXXXXX56
                        </h4>
                      </div>
                      <span class="text-white">299</span>
                    </div>
                    <div style="display: flex;justify-content: space-between;">
                      <p style="margin-left: 15px;margin-top: 0;" class="text-white">16 Feb, <span class="text-white">15:00 PM</span></p>
                      <span class="text-white">Debit Card</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>

  
</div> -->



<div class="main row">
  <!-- !----!----! -->


  <div class="head card  d-flex flex-row col-lg-12">

    <div class=" col-lg-2">
      <img src=".\assets\images\c1.png" alt="img1" style="width:50px;"><span class="fw-bold  mx-2  text-white "
        style="font-size: 18px;">Dashboard</span>
    </div>


  </div>

  <!-- <div class="col-lg-12  mt-3 card flex-row ">
      <div class="col-lg-3 card ">
        <div class="text-center">
          <img src=".\assets\images\user 1.png" alt="img1" style="width:80px;">
        </div>
     <h1>Total Active users </h1>
      </div>
      <div class="col-lg-3 card ">
        <div class="text-center">
          <img src=".\assets\images\h1'.png" alt="img2" style="width:80px;">
        </div>
        <h1>Hotspot Active </h1>
         </div>
      <div class="col-lg-3 card ">
        <div class="text-center">
          <img src=".\assets\images\unable (1).png" alt="img3" style="width:80px;">
        </div>
        <h1>Inactive users</h1>
      </div>
      <div class="col-lg-3 card ">
        <div class="text-center">
          <img src=".\assets\images\n.png" alt="img4" style="width:80px;">
        </div>
          <h1>Network usage</h1>
        </div>
  </div> -->
  <div class="col-lg-12 row  mt-3 " style="margin: 0;padding: 0;">
    <!-- !----!main-----! -->

    <div class="col-3 col-lg-3">
      <div class="main-card mb-3 card " (click)="openLarge(content1)">
        <div class="card-body">
          <div style="display: flex;justify-content: center;">
            <!-- <i class="bi bi-people-fill" style="font-size: larger;"></i> -->
            <img src=".\assets\images\user 1.png" alt="img1" width="65px">
          </div>
          <div class="text-center text-white">
            <h3>TOTAL USERS</h3>
            <h2>{{users}}U+</h2>
          </div>
          <!-- <button class="btn bg-info"  >Click</button> -->
        </div>
      </div>
    </div>
    <!-- !----!----! -->
    <div class="col-3 col-lg-3 ">
      <div class="main-card mb-3  card " (click)="openLarge(content10)">
        <div class="card-body">
          <div style="display: flex;justify-content: center;">
            <img src=".\assets\images\hotn.png" alt="user" width="65px">
          </div>
          <div class="text-center text-white">
            <h3> HOTSPOT ACTIVE</h3>
            <h2>200U+</h2>
          </div>
          <!-- <button class="btn bg-info ">View</button> -->
        </div>
      </div>
    </div>
    <!-- !-----!----! -->
    <div class="col-3 col-lg-3 ">
      <div class="main-card  mb-3 card " (click)="openLarge(content11)">
        <div class="card-body">
          <div style="display: flex;justify-content: center;">
            <img src=".\assets\images\unable (1).png" alt="user" width="65px">
          </div>
          <div class="text-center text-white">
            <h3>INACTIVE USRES </h3>
            <h2>50U+</h2>
          </div>
          <!-- <button class="btn bg-info " >Click</button> -->
        </div>
      </div>
    </div>
    <!-- !-----!---! -->
    <div class="col-3 col-lg-3 ">
      <div class="main-card mb-3  card " (click)="openLarge(content14)">
        <div class="card-body">
          <div style="display: flex;justify-content: center;">
            <img src=".\assets\images\n.png" alt="user" width="65px">
          </div>
          <div class="text-center text-white">
            <h3>NETWORK USAGES</h3>
            <h2>200Gb</h2>
          </div>
          <!-- <button class="btn bg-info " >Click</button>   -->
        </div>
      </div>
    </div>
    <!-- !-----!----! -->
  </div>



  <!-- !-----!----! -->
  <div class="row " style="margin: 0;padding: 0">
    <div class="col-sm-12 col-lg-6">
      <div class="mb-3 card">
        <div class="card-header-tab card-header"
          style="background: linear-gradient(90deg, #0071bc, #33a1f2);border-bottom: 1px solid white;">
          <div class="card-header-title font-size-lg text-capitalize fw-normal">
            <i class="header-icon lnr-cloud-download icon-gradient bg-happy-itmeo"> </i>
            <h2 class="text-dark fw-bold text-white">WAN DATA TRANSFER</h2>
          </div>
        </div>
        <div class="p-0 card-body" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
          <div class="p-1 slick-slider-sm mx-auto">
            <div class="widget-chart widget-chart2 text-start p-0">
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content widget-chart-content-lg pb-0">
                  <div class="widget-numbers">
                  </div>
                </div>
                <div class="widget-chart-wrapper he-auto opacity-10 m-0">
                  <div class="d-block">
                    <canvas baseChart [datasets]="barChartDatad" [labels]="barChartLabels" [options]="barChartOptions"
                      [chartType]="barChartType" style="height:215px;">
                    </canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h6 class="text text-uppercase font-size-md  ps-3 pe-3 pb-1 fw-bold text-white" style="padding-left: 17px;">
            Bandwidth
            Progress</h6>
          <ul class="list-group list-group-flush">
            <li class="p-3 bg-transparent list-group-item">
              <div class="widget-content p-0">
                <div class="widget-content-outer">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left">
                      <div class="widget-heading fw-bold text-white">Total Bandwidth</div>
                    </div>

                  </div>
                  <div class="widget-progress-wrapper">
                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                      <div class="progress-bar " role="progressbar" aria-valuenow="43" aria-valuemin="0"
                        aria-valuemax="100" style="background-color: #ff9c5a;" [style.width.%]="valueFromAPI">
                        {{valueFromAPI}}%</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div class="col-sm-12 col-lg-6">
      <div class="mb-3 card">
        <div class="card-header-tab card-header"
          style="background: linear-gradient(90deg, #0071bc, #33a1f2);border-bottom: 1px solid white;">
          <div class="card-header-title font-size-lg text-capitalize fw-normal">
            <i class="header-icon lnr-cloud-download icon-gradient bg-happy-itmeo"> </i>
            <h2 class="text-dark fw-bold text-white">WAN BANDWIDTH</h2>
          </div>
        </div>
        <div class="p-0 card-body" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
          <div class="p-1 slick-slider-sm mx-auto">
            <div class="widget-chart widget-chart2 text-start p-0">
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content widget-chart-content-lg pb-0">
                  <div class="widget-numbers">
                  </div>
                </div>
                <div class="widget-chart-wrapper he-auto opacity-10 m-0">
                  <div class="d-block">
                    <canvas baseChart [datasets]="bandwidthChartData" [labels]="bandwidthChartLabels"
                      [options]="bandwidthChartOptions" [chartType]="bandwidthChartType" style="height:215px;">
                    </canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h6 class="text text-uppercase font-size-md  ps-3 pe-3 pb-1 fw-bold text-white">Bandwidth
            Progress</h6>
          <ul class="list-group list-group-flush">
            <li class="p-3 bg-transparent list-group-item">
              <div class="widget-content p-0">
                <div class="widget-content-outer">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left">
                      <div class="widget-heading fw-bold text-white">Total Bandwidth</div>
                    </div>

                  </div>
                  <div class="widget-progress-wrapper">
                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                      <div class="progress-bar " role="progressbar" aria-valuenow="43" aria-valuemin="0"
                        aria-valuemax="100" style="width:63%;background-color: #ff9c5a;">
                        70%</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div class="col-sm-12 col-lg-6">
      <div class="mb-3 card">
        <div class="card-header-tab card-header"
          style="background: linear-gradient(90deg, #0071bc, #33a1f2);border-bottom: 1px solid white;">
          <div class="card-header-title font-size-lg text-capitalize fw-normal">
            <i class="header-icon lnr-cloud-download icon-gradient bg-happy-itmeo"> </i>
            <h2 class="text-dark fw-bold text-white">SYSTEM RESOURCES</h2>
          </div>
        </div>
        <div class="p-0 card-body" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
          <div class="p-1 slick-slider-sm mx-auto">
            <div class="widget-chart widget-chart2 text-start p-0">
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content widget-chart-content-lg pb-0">

                  <div class="widget-numbers">
                  </div>
                </div>
                <div class="widget-chart-wrapper he-auto opacity-10 m-0">
                  <div class="d-block">
                    <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
                      [chartType]="bandwidthChartType" style="height:215px;">
                    </canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h6 class="text text-uppercase font-size-md  fw-bold text-white" style="padding-left: 16px;">Bandwidth
              Progress</h6>
          </div>
          <ul class="list-group list-group-flush">
            <li class="p-3 bg-transparent list-group-item">
              <div class="widget-content p-0">
                <div class="widget-content-outer">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left">
                      <div class="widget-heading fw-bold text-white">Total Bandwidth</div>
                    </div>

                  </div>
                  <div class="widget-progress-wrapper">
                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                      <div class="progress-bar " role="progressbar" aria-valuenow="43" aria-valuemin="0"
                        aria-valuemax="100" style="width:25%;background-color: #ff9c5a;">
                        40%</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>




    <div class="col-sm-12 col-lg-6">
      <div class="mb-3 card">
        <div class="card-header-tab card-header"
          style="background: linear-gradient(90deg, #0071bc, #33a1f2);border-bottom: 1px solid white;">
          <div class="card-header-title font-size-lg text-capitalize fw-normal">
            <i class="header-icon lnr-cloud-download icon-gradient bg-happy-itmeo"> </i>
            <h2 class="text-dark fw-bold text-white">CPU CORE USAGE</h2>
          </div>
        </div>
        <div class="p-0 card-body" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
          <div class="p-1 slick-slider-sm mx-auto">
            <div class="widget-chart widget-chart2 text-start p-0">
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content widget-chart-content-lg pb-0">

                  <div class="widget-numbers">
                  </div>
                </div>
                <div class="widget-chart-wrapper he-auto opacity-10 m-0">
                  <div class="d-block">
                    <canvas baseChart [datasets]="barChartDatass" [labels]="barChartLabelss"
                      [options]="barChartOptionss" [chartType]="barChartTypess" style="height:215px;">
                    </canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h6 class="text text-uppercase font-size-md   fw-bold text-white" style="padding-left: 16px;">Bandwidth
              Progress</h6>
          </div>
          <ul class="list-group list-group-flush" style="padding: 2px;">
            <li class="p-3 bg-transparent list-group-item">
              <div class="widget-content p-0">
                <div class="widget-content-outer">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left">
                      <div class="widget-heading fw-bold text-white">Total Bandwidth</div>
                    </div>
                  </div>
                  <div class="widget-progress-wrapper">
                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                      <div class="progress-bar " role="progressbar" aria-valuenow="43" aria-valuemin="0"
                        aria-valuemax="100" style="width: 35%;background-color: #ff9c5a;">
                        50%</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- !-----!----! -->
  <div class="mb-3 card card-body  mx-2 text-center" id="datausage">
    <div class="text-white">
      <img src=".\assets\images\data.png" alt="usages" width="45px"><span class="h2 mx-2"
        style="font-weight:600;font-size: 18px;">DATA USAGE</span>
    </div>
  </div>

  <div class="col-sm-12 col-lg-6">
    <div class="mb-3 card">
      <div class="card-header-tab card-header"
        style="background: linear-gradient(90deg, #0071bc, #33a1f2);border-bottom: 1px solid white;">
        <div class="card-header-title font-size-lg text-capitalize fw-normal">
          <i class="header-icon lnr-cloud-download icon-gradient bg-happy-itmeo"> </i>
          <h2 class="text-dark fw-bold text-white">This Week</h2>
        </div>
      </div>
      <div class="p-0 card-body" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
        <div class="p-1 slick-slider-sm mx-auto">
          <div class="widget-chart widget-chart2 text-start p-0">
            <div class="widget-chat-wrapper-outer">
              <div class="widget-chart-content widget-chart-content-lg pb-0">
                <div class="widget-numbers"></div>
              </div>
              <div class="widget-chart-wrapper he-auto m-0">
                <div class="card-body p-3">
                  <canvas baseChart [datasets]="barChartDataw" [labels]="barChartLabelsw" [options]="barChartOptionsw"
                    [legend]="barChartLegendw" [plugins]="barChartPluginsw" [chartType]="barChartTypew">
                  </canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="col-sm-12 col-lg-6">
    <div class="mb-3 card">
      <div class="card-header-tab card-header"
        style="background: linear-gradient(90deg, #0071bc, #33a1f2);border-bottom: 1px solid white;">
        <div class="card-header-title font-size-lg text-capitalize fw-normal">
          <i class="header-icon lnr-cloud-download icon-gradient bg-happy-itmeo"> </i>
          <h2 class="text-dark fw-bold text-white">This Month</h2>
        </div>
      </div>
      <div class="p-0 card-body" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
        <div class="p-1 slick-slider-sm mx-auto">
          <div class="widget-chart widget-chart2 text-start p-0">
            <div class="widget-chat-wrapper-outer">
              <div class="widget-chart-content widget-chart-content-lg pb-0">

                <div class="widget-numbers">
                </div>
              </div>
              <div class="widget-chart-wrapper he-auto opacity-10 m-0">
                <div class="card-body">
                  <canvas baseChart [datasets]="barChartDatam " [labels]="barChartLabelsm" [options]="barChartOptionsm"
                    [legend]="barChartLegendm" [chartType]="barChartTypem" height="266px " width="533px">
                  </canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
        </div>

      </div>
    </div>
  </div>


<div class="usage-list-section">
    <div class="row">
  <!-- !-----!-----! -->
  <div class="col-lg-6">
    <div class="row">
      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 card-btm-border " id="c">
          <div class="text-center">
            <img src=".\assets\images\current.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Current Balance</h3>

          </div>
          <div>
            <button class="btn bg-info" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);"
              (click)="openLarge(content21)">View</button>
          </div>
        </div>
      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border  text-center" id="c"
          style=" box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);">
          <div class="text-center">
            <img src=".\assets\images\inf3.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Unlimited Pack</h3>

          </div>
          <div>
            <button class="btn bg-info"
              style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">View</button>
          </div>

        </div>
      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border " id="c">
          <div class="text-center">
            <img src=".\assets\images\method 1.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Payment Method</h3>

          </div>
          <div>
            <button class="btn bg-info"
              style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">View</button>
          </div>

        </div>
      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border " id="c">
          <div class="text-center">
            <img src=".\assets\images\plan.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Plans</h3>

          </div>
          <div>
            <button class="btn bg-info" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);"
              (click)="openLarge(content15)">View</button>
          </div>
        </div>

      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border " id="c">
          <div class="text-center">
            <img src=".\assets\images\days.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Total Days</h3>

          </div>
          <div>
            <button class="btn bg-info" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);"
              data-toggle="modal" data-target="#exampleModal" (click)="openLarge(content25)">View</button>
          </div>
        </div>
      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border " id="c">
          <div class="text-center">
            <img src=".\assets\images\expired.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Expired Date</h3>
          </div>
          <div>
            <button class="btn bg-info" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);"
              (click)="openLarge(content18)">View</button>
          </div>
        </div>
      </div>



    </div>
  </div>
  <!-- !-----!---! -->




  <!-- !-----!----! -->
  <!-- <div class="col-sm-12 col-lg-6 mb-3 " style="height: 68vh;" >
      <div class="card-hover-shadow-2x card" style="background: linear-gradient(90deg, #0071bc, #33a1f2);height: 68vh;">
        <div class="card-header-tab card-header" style="background: linear-gradient(90deg, #0071bc, #33a1f2);border:none"   >
          <div class="card-header-title font-size-lg text-capitalize fw-normal">
           <div class="text-center">
            <img src=".\assets\images\sup.png" alt="" style="width: 30px;">
           </div>
           <div class="text-center text-white">
            <h5>Help & Support</h5>
           </div>
           
          </div>
        </div>
        <div class="scroll-area-lg">
          <perfect-scrollbar [autoPropagation]="true">
            <div class="col-lg-12  row" style="display: flex;justify-content: center;align-items: center;padding:45px;margin:0">
             
             <div class="col-lg-5 mb-3 card ">
             <div class="text-center ">
               <img src=".\assets\images\in.jpg" alt="" style="width:50px;">
             </div>
             <div class="text-center">
              <h5 class="text-dark fw-bold">LIVE CHAT🤩</h5>
             </div>
             </div>

              <div class="col-lg-5 mb-3 card  mx-3">
                <div class="text-center ">
                  <img src=".\assets\images\track.png" alt=""  style="width:50px;">
                </div>
                <div class="text-center">
                 <h5 class="text-dark fw-bold">TRACK REQUEST</h5>
                </div>
              </div>

              <div class="col-lg-5 mb-3  card">
                
                <div class="text-center ">
                  <img src=".\assets\images\t.png" alt=""  style="width:50px;">
                </div>
                <div class="text-center">
                 <h5 class="text-dark fw-bold">TROUBLE SHOOTING</h5>
                </div>
               </div>

               <div class="col-lg-5 mb-3  card  mx-3">
                <div class="text-center ">
                  <img src=".\assets\images\microphone.png" alt=""  style="width:50px;">
                </div>
                <div class="text-center">
                 <h5 class="text-dark fw-bold">VOICES </h5>
                </div>
               </div>

               <div class="col-lg-5 mb-3  card ">
                <div class="text-center ">
                  <img src=".\assets\images\report.png" alt=""  style="width:50px;">
                </div>
                <div class="text-center">
                 <h5 class="text-dark fw-bold">REPORT SIM</h5>
                </div>
               </div>

               <div class="col-lg-5  mb-3  card mx-3">
                <div class="text-center ">
                  <img src=".\assets\images\do-not-disturb.png" alt="" style="width:50px;">
                </div>
                <div class="text-center">
                 <h5 class="text-dark fw-bold">DO NOT DISTURB</h5>
                </div>
               </div>

              </div>
          </perfect-scrollbar>
        </div>
      </div>
    </div>   -->
  <!-- !----!----! -->
  <!-- !-----!-----! -->

  <!-- <div class="col-sm-12 col-lg-6">
      <div class="row">
         
          <div class="col-lg-6">
          <div class="card mb-3 widget-chart widget-chart2  card-btm-border " style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
            <div class="text-center" >
              <img src=".\assets\images\plan.png" alt="" width="80px">
            </div>
             <div class="text-center text-white">
              <h4>Change User plan</h4>
            </div>
            <div>
              <button class="btn btn-info text-white  text-center" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">View </button>
            </div> 
           
          </div>
         </div> 
   
         <div class="col-lg-6">
          <div class="card mb-3 widget-chart widget-chart2  card-btm-border" style="background: linear-gradient(90deg, #0071bc, #33a1f2);" >
            <div class="text-center" >
              <img src=".\assets\images\speed.png" alt="" width="80px">
            </div>
             <div class="text-center text-white">
              <h4>Network Speed</h4>
              <h4>50Mbs</h4>
            </div> 
           </div>
        </div>  -->
  <!-- <div class="col-lg-6">
          <div class="card mb-3 widget-chart widget-chart2 card-btm-border" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
            <div class="text-center">
              <canvas id="gaugeChart" width="200" height="100"></canvas>
            </div>
            <div class="text-center text-white">
              <h5>Network Bandwidth</h5>
            </div>
          </div>
        </div>  -->


  <!-- 
    </div>
      </div> -->

  <!-- !-----chats!----! -->

  <div class="col-lg-6">
    <div class="row">
      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 card-btm-border " id="c">
          <div class="text-center">
            <img src=".\assets\images\current.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Today Usages</h3>

          </div>
          <div>
            <button class="btn bg-info" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);"
              (click)="openLarge(content20)">View</button>
          </div>
        </div>
      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border text-center" id="c">
          <div class="text-center">
            <img src=".\assets\images\plan.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Change User plan</h3>

          </div>
          <div>
            <button class="btn bg-info"
              style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">View</button>
          </div>

        </div>
      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border card-shadow-warning " id="c">
          <div class="text-center">
            <img src=".\assets\images\speed.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Network Speed</h3>

          </div>
          <div>
            <button class="btn bg-info"
              style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">View</button>
          </div>

        </div>
      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border " id="c">
          <div class="text-center">
            <img src=".\assets\images\sim.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Switch SIM</h3>

          </div>
          <div>
            <button class="btn bg-info"
              style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">Click</button>
          </div>
        </div>

      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border card-shadow-info" id="c">
          <div class="text-center">
            <img src=".\assets\images\recharge.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Recharge</h3>

          </div>
          <div>
            <button class="btn bg-info"
              style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">View</button>
          </div>
        </div>
      </div>

      <div class="col-4 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border card-shadow-warning" id="c">
          <div class="text-center">
            <img src=".\assets\images\set.png" alt="" width="60px">
          </div>
          <div class="text-center text-white">
            <h3>Setting</h3>
          </div>
          <div>
            <button class="btn bg-info"
              style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">Click</button>
          </div>
        </div>
      </div>



    </div>
  </div>
</div>
</div>



  <!-- !-----!-----! -->

  <!-- <div class="col-lg-12">
          <div class="card mb-3 widget-chart widget-chart2 text-start" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
            <div class="card-body" >
              <canvas baseChart
                [datasets]="barChartDataw "
                [labels]="barChartLabelsw"
                [options]="barChartOptionsw"
                [legend]="barChartLegend"
                [chartType]="barChartTypew" width="180px" height="139px">
              </canvas>
            </div>
          </div>
        </div>  -->

  <!-- <div class="col-lg-6">
          <div class="card mb-3 widget-chart widget-chart2 text-start " style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
            <div class="card-body" >
              <h1 class="text-white fw-bold">Todays</h1>
              <h3 class="text-white fw-bold">500mbs</h3>
            </div>
          </div>
        </div> -->

  <!-- <div class="col-lg-12">
          <div class="card mb-3 widget-chart widget-chart2 text-start" >
            <div class="card-body" >
              <canvas baseChart
                [datasets]="barChartDatam "
                [labels]="barChartLabelsm"
                [options]="barChartOptionsm"
                [legend]="barChartLegendm"
                [chartType]="barChartTypem" width="514px " height="160px">
              </canvas>
            </div>
          </div>
        </div> -->

  <!-- !-----!---! -->

  <!-- !-----!----! -->
  <div class="col-sm-12 col-lg-6 trending">
    <div class="row">
      <div class="mb-3 card card-body  mx-2 text-center" id="tn">
        <div class="text-white">
          <img src=".\assets\images\trend.png" alt="usages" width="60px"><span class="h2 fw-bold mx-2"
            style="font-weight:600;font-size: 18px;">Trending Now</span>
        </div>
      </div>

      <div class="col-6 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border " id="c">

          <div class="text-center">
            <img src=".\assets\images\subscription.png" alt="" width="50px">
          </div>
          <div class="text-center text-white">
            <h4>Subscription</h4>
            <h4>50days</h4>
          </div>
          <div class="text-center text-white">
            <button class="btn bg-info" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);"
              (click)="openLarge(content26)">View</button>
          </div>
        </div>
      </div>

      <div class="col-6 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2  card-btm-border" id="c">
          <div class="text-center">
            <img src=".\assets\images\dis.png" alt="" width="50px">
          </div>
          <div class="text-center text-white">
            <h4>Discount</h4>
            <h4>50days</h4>
          </div>
          <div class="text-center text-white">
            <button class="btn bg-info" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);"
              (click)="openSmall(content27)">View</button>
          </div>
        </div>
      </div>



      <div class="col-6 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2" id="c">
          <div class="text-center">
            <img src=".\assets\images\popular.png" alt="" width="50px">
          </div>
          <div class="text-center text-white">
            <h4>Popular plan</h4>
            <h4>50days</h4>
          </div>
          <div class="text-center text-white">
            <button class="btn bg-info" style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);"
              (click)="openLarge(content16)">View</button>
          </div>
        </div>
      </div>

      <div class="col-6 col-lg-6">
        <div class="card mb-3 widget-chart widget-chart2 " id="c">
          <div class="text-center">
            <img src=".\assets\images\auto.png" alt="" width="50px">
          </div>
          <div class="text-center text-white">
            <h4>Auto Recharge</h4>
            <h4>100days</h4>
          </div>
          <div class="text-center text-white">
            <button class="btn bg-info"
              style="background: linear-gradient(90deg, #fe804e, #ff9c5a, #ffad66);">View</button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- !-----!-----! -->


  <div class="col-sm-12 col-lg-6 mb-3 ">
    <div class="card-hover-shadow-2x card" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
      <div class="card-header-tab card-header" style="background: linear-gradient(90deg, #0071bc, #33a1f2);border:none">
        <div class="card-header-title font-size-lg text-capitalize fw-normal">
          <div class="text-center">
            <img src=".\assets\images\sup.png" alt="" style="width: 30px;">
          </div>
          <div class="text-center text-white">
            <h5 style="font-weight:600;font-size: 18px;">Help & Support</h5>
          </div>

        </div>
      </div>
          <div class="col-lg-12  row help">

            <div class="col-4 col-lg-5 mb-3">
              <div class="card">
                <div class="text-center ">
                  <img src=".\assets\images\in.jpg" alt="">
                </div>
                <div class="text-center">
                  <h5 class="text-dark fw-bold">Live Chat🤩</h5>
                </div>
              </div>
            </div>

            <div class="col-4 col-lg-5 mb-3 ">
              <div class="card">
                <div class="text-center ">
                  <img src=".\assets\images\track.png" alt="">
                </div>
                <div class="text-center">
                  <h5 class="text-dark fw-bold">Track Request</h5>
                </div>
              </div>
            </div>

            <div class="col-4 col-lg-5 mb-3">
              <div class="card">
                <div class="text-center ">
                  <img src=".\assets\images\t.png" alt="">
                </div>
                <div class="text-center">
                  <h5 class="text-dark fw-bold">Trouble Shooting</h5>
                </div>
              </div>
            </div>

            <div class="col-4 col-lg-5 mb-3">
              <div class="card">
                <div class="text-center ">
                  <img src=".\assets\images\microphone.png" alt="">
                </div>
                <div class="text-center">
                  <h5 class="text-dark fw-bold">Voice </h5>
                </div>
              </div>
              
            </div>

            <div class="col-4 col-lg-5 mb-3">
              <div class="card">
                <div class="text-center ">
                  <img src=".\assets\images\report.png" alt="">
                </div>
                <div class="text-center">
                  <h5 class="text-dark fw-bold">Report SIM</h5>
                </div>
              </div>
            </div>

            <div class="col-4 col-lg-5  mb-3">
              <div class="card">
                <div class="text-center ">
                  <img src=".\assets\images\do-not-disturb.png" alt="">
                </div>
                <div class="text-center">
                  <h5 class="text-dark fw-bold">Do Not Distrub</h5>
                </div>
              </div>
            </div>

          </div>
    
    </div>
  </div>
  <!-- !-----!----! -->
  <div class="card mb-3" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
    <div class="g-0 row">
      <div class="col-md-12 col-lg-4">
        <ul class="list-group list-group-flush">
          <li class="bg-transparent list-group-item">
            <div class="widget-content p-0">
              <div class="widget-content-outer">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left">
                    <div class="widget-heading  text-white fw-bold opacity-10">Total Recharge</div>

                  </div>
                  <div class="widget-content-right">
                    <div class="widget-numbers text-white">500RS</div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="bg-transparent list-group-item">
            <div class="widget-content p-0">
              <div class="widget-content-outer">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left">
                    <div class="widget-heading  text-white fw-bold">Total Topup Used</div>

                  </div>
                  <div class="widget-content-right">
                    <div class="widget-numbers text-white">60days</div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-12 col-lg-4">
        <ul class="list-group list-group-flush">
          <li class="bg-transparent list-group-item">
            <div class="widget-content p-0">
              <div class="widget-content-outer">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left">
                    <div class="widget-heading  text-white fw-bold">Total prepaid usages </div>
                  </div>
                  <div class="widget-content-right">
                    <div class="widget-numbers text-white">50days</div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="bg-transparent list-group-item">
            <div class="widget-content p-0">
              <div class="widget-content-outer">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left">
                    <div class="widget-heading  text-white fw-bold">Total postpaid usages</div>

                  </div>
                  <div class="widget-content-right">
                    <div class="widget-numbers text-white">20days</div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-12 col-lg-4">
        <ul class="list-group list-group-flush">
          <li class="bg-transparent list-group-item">
            <div class="widget-content p-0">
              <div class="widget-content-outer">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left">
                    <div class="widget-heading  text-white fw-bold">Total Active days</div>

                  </div>
                  <div class="widget-content-right">
                    <div class="widget-numbers text-white">1896</div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="bg-transparent list-group-item">
            <div class="widget-content p-0">
              <div class="widget-content-outer">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left">
                    <div class="widget-heading  text-white fw-bold">Total Toup Value</div>

                  </div>
                  <div class="widget-content-right">
                    <div class="widget-numbers text-white">$12.6k</div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>




    <!-- !-----!---! -->
  </div>

  <!-- !-----!pop up-----! -->

  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content1 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Total Users</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">

          <!-- <div class="card-header mb-3" style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
        
         <button class="btn  text-center text-white  mx-2" style="background-color: green;" (click)="openChild(content13)"><span class=" text-white"><i class="bi bi-plus" ></i></span>Add</button> 

        <button class="btn  text-center text-white mx-2" (click)="Delete()" style="background-color: red;"><span><i class="bi bi-x "  id="s"></i></span>Delete</button> 

      </div> -->

          <!-- !----!---! -->




          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>



                <button class="btn  text-center text-white  mx-2" style="background-color: green;"><span
                    class=" text-white"><i class="bi bi-plus"></i></span>Add</button>

                <button class="btn  text-center text-white mx-2" (click)="Deletes($event)" (change)="d()"
                  style="background-color: red;"><span><i class="bi bi-x " id="s"></i></span>Delete</button>

              </ng-template>
              <ng-template ngbPanelContent>
                <div>
                  <form [formgroup]="addusers">
                    <div class="row col-lg-12">


                      <div class="col-lg-6 ">
                        <label class="col-lg-6 mb-2" style=" color:#0071bc;font-weight: bold;">User ID</label>
                        <div class="col-lg-12">
                          <input type="text" name="" id="" class="form-control"
                            style=" box-shadow: inset 0.2rem 0.2rem 0.5rem #c8d0e7, inset -0.2rem -0.2rem 0.5rem #ffffff;"
                            formcontrolname="user_id">
                        </div>
                      </div>
                      <div class="col-lg-6 ">
                        <label class="col-lg-6 mb-2" style="color:#0071bc;font-weight: bold;">User Name</label>
                        <div class="col-lg-12">
                          <input type="text" name="" id="" class="form-control"
                            style=" box-shadow: inset 0.2rem 0.2rem 0.5rem #c8d0e7, inset -0.2rem -0.2rem 0.5rem #ffffff;"
                            formcontrolname="user_name">
                        </div>
                      </div>

                      <div class="col-lg-6 mt-1">
                        <label class="col-lg-6 mb-2" style="color:#0071bc;font-weight: bold;">User Status</label>
                        <div class="col-lg-12">
                          <input type="text" name="" id="" class="form-control"
                            style=" box-shadow: inset 0.2rem 0.2rem 0.5rem #c8d0e7, inset -0.2rem -0.2rem 0.5rem #ffffff;">
                        </div>
                      </div>

                      <div class="col-lg-6 mt-1">
                        <label class="col-lg-6 mb-2" style="color:#0071bc;font-weight: bold;">Bandwidth</label>
                        <div class="col-lg-12">
                          <input type="text" name="" id="" class="form-control"
                            style=" box-shadow: inset 0.2rem 0.2rem 0.5rem #c8d0e7, inset -0.2rem -0.2rem 0.5rem #ffffff;">
                        </div>
                      </div>


                    </div>

                    <div class="mt-2">
                      <button class="btn bg-primary fw-bold text-center mx-2 mt-2"
                        (click)="save(addusers.value)">Submit</button>
                    </div>

                  </form>

                </div>

              </ng-template>
            </ngb-panel>

          </ngb-accordion>
          <!-- !----!---! -->

          <div class=" card-body table-responsive  col-lg-12  mt-4 "
            style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
            <table>
              <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
                <tr class="text-white text-center">
                  <td style="padding:10px">
                    <input type="checkbox">
                  </td>
                  <td style="padding:10px;">User ID</td>
                  <td style="padding:10px;">User Name</td>
                </tr>
              </thead>
              <thead>
                <tr *ngFor="let i of uservalue">
                  <th style="padding: 10px 10px;">
                    <input type="checkbox">
                  </th>
                  <th style="padding: 10px 10px;">{{i.userid
                    }}</th>
                  <th style="padding: 10px 10px;">
                    <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;"><span
                      class="mx-1">{{i.username}}</span>
                  </th>
                </tr>
              </thead>
            </table>
          </div>


        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>


  <!-- !-----!hotspot----! -->
  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content10 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Total Hotspot Active</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">
          <div class=" card-body table-responsive col-lg-12  "
            style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
            <table>
              <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
                <tr class="text-white text-center">
                  <td style="padding:10px">
                    <input type="checkbox">
                  </td>
                  <td style="padding:10px;">User ID</td>
                  <td style="padding:10px;">User Name</td>
                  <td style="padding:10px;">Status</td>
                </tr>
              </thead>
              <thead>
                <tr *ngFor="let i of uservalue">
                  <th style="padding: 10px 10px;">
                    <input type="checkbox">
                  </th>
                  <th style="padding: 10px 10px;">{{i.userid}}</th>
                  <th style="padding: 10px 10px;">
                    <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;" class="mx-1"><span
                      class="mx-1">{{i.username}}</span>
                  </th>
                  <th style="padding: 10px 10px;">
                    <button class="btn  text-center fw-bold text-white"
                      style="background: linear-gradient(45deg, #00ff00, #0080ff);border-radius: 35px;" placement="top"
                      ngbTooltip="User is Active ">{{i.status}}</button>
                  </th>
                </tr>
              </thead>
            </table>
          </div>


        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>

  <!-- !----!Inactive-----! -->

  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content11 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Total Inactive Users</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>


        <!-- <div class=" card-body table-responsive col-lg-12  " style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
          <table>
            <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
              <tr class="text-white text-center">
                <td style="padding:10px">
                  <input type="checkbox">
                </td>
                <td style="padding:10px;">User ID</td>
                <td style="padding:10px;">User Name</td>
                <td style="padding:10px;">Status</td>
              </tr>
            </thead>
            <thead>
              <tr *ngFor="let i of values" >
                <th  style="padding: 10px 10px;" >
                  <input type="checkbox">
                </th>
                 <th  style="padding: 10px 10px;" >{{i.id}}</th>
                 <th  style="padding: 10px 10px;" >
                  <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;" class="mx-1">{{i.name}}
                 </th>
                 <th  style="padding: 10px 10px;" >
                   <button class="btn  text-center fw-bold text-white" style="background: linear-gradient(45deg, #A52A2A, #FF4500);border-radius: 35px;">{{i.statuss}}</button>
                 </th>
              </tr>
            </thead>
          </table>

         </div> -->
        <div class="modal-body" style="background-color:ghostwhite;">

          <div class=" card-body table-responsive col-lg-12 "
            style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
            <table>
              <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
                <tr class="text-white text-center">
                  <td style="padding:10px">
                    <input type="checkbox">
                  </td>
                  <td style="padding:10px;">User ID</td>
                  <td style="padding:10px;">User Name</td>
                  <td style="padding:10px;">Status</td>
                </tr>
              </thead>
              <thead>
                <tr *ngFor="let i of uservalue">
                  <th style="padding: 10px 10px;">
                    <input type="checkbox">
                  </th>
                  <th style="padding: 10px 10px;">{{i.userid}}</th>
                  <th style="padding: 10px 10px;">
                    <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;" class="mx-1">{{i.username}}
                  </th>
                  <th style="padding: 10px 10px;">
                    <button class="btn  text-center fw-bold text-white"
                      style="background: linear-gradient(45deg, #A52A2A, #FF4500);border-radius: 35px;">{{i.status}}</button>
                  </th>

                </tr>
              </thead>
            </table>
          </div>


        </div>



        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>

  <!-- !-----!users add-----! -->

  <!-- <div class="card main-card " style="display: none;">
  <div class="card-body">
    <ng-template #content13 let-c="close" let-d="dismiss">
      <div class="modal-header" style="background-color: ghostwhite;" >
        <div class="container ">
          <h3 style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; " class="text-center">Total Users</h3> 
        </div>
        <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
        </button>
      </div>
      <div class="modal-body" style="background-color:ghostwhite;">
        
       

        
      </div>
      <div class="modal-footer" style="background-color: ghostwhite;" >
        <button type="button" class="btn text-center text-white fw-bold px-4" style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
        <button type="button" class="btn text-center text-white fw-bold px-4" style="background: linear-gradient(90deg, #0071bc, #33a1f2);"(click)="c('Close click')">Close</button>
       
      </div>
    </ng-template>
  </div>
</div> -->


  <!-- !-----!Network----! -->

  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content14 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Total Network Usages</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">



          <div class=" card-body table-responsive col-lg-12  "
            style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
            <table>
              <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
                <tr class="text-white text-center">
                  <td style="padding:10px">
                    <input type="checkbox">
                  </td>
                  <td style="padding:10px;">User ID</td>
                  <td style="padding:10px;">User Name</td>
                  <td style="padding:10px;">Status</td>
                </tr>
              </thead>
              <thead>
                <tr *ngFor="let i of uservalue">
                  <th style="padding: 10px 10px;">
                    <input type="checkbox">
                  </th>
                  <th style="padding: 10px 10px;">{{i.userid}}</th>
                  <th style="padding: 10px 10px;">
                    <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;" class="mx-1">{{i.username}}
                  </th>
                  <th style="padding: 10px 10px;">
                    <button class="btn  text-center fw-bold text-white"
                      style="background: linear-gradient(45deg, #00ff00, #0080ff);border-radius: 35px;">{{i.data}}</button>
                  </th>
                </tr>
              </thead>
            </table>
          </div>


        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>


  <!-- !----!plans-----!---! -->
  <div class="card main-card " style="display: none;">
    <div class="card-body">

      <ng-template #content15 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Total Current Plan</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">
          <div class="scroll-area-lg ">
            <perfect-scrollbar [autoPropagation]="true">
              <div class="row"
                style="justify-content:space-around;flex-wrap: wrap;padding: 10px;padding-left: 15px;padding-right: 15px;">

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;"
                      (click)="open(content)">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1),  0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>
                </div>
                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>



                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>

                <div class="card col-lg-4 mb-3"
                  style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;">
                  <h1 class="text-dark fw-bold" style="padding-left: 10px;">{{plans}}</h1>
                  <div class="row mt-2" style="padding-left: 10px;">
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                      <h3 style="font-size: 18px;">Validity</h3>
                    </div>
                    <div style="width: 120px;">
                      <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                      <h3 style="font-size: 18px;">Data</h3>
                    </div>
                  </div>
                  <div class="mb-3 text-center mt-1">
                    <button class="btn  text-white text-center"
                      style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                  </div>

                </div>
                <!-- !----End!---! -->

              </div>
            </perfect-scrollbar>
          </div>






        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>

    </div>
  </div>


  <!-- !----!popuper plans-----! -->

  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content16 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Popular Plans</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">
          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>
                <div class="row " style="justify-content: space-between;width: 732px;display: flex;">
                  <div style="width: 270px;">
                    <span class="card-header--title">Top Trending True 5G Unlimited Plans</span>
                  </div>
                  <div style="width: 35px;">
                    <img src=".\assets\images\plus.png" alt="" style="width: 16px;">
                  </div>
                </div>

              </ng-template>
              <ng-template ngbPanelContent>
                <div class="col-lg-12 row" style="margin: 0;padding: 0;">


                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!-- !----!---! -->
          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>
                <div class="row " style="justify-content: space-between;width: 732px;display: flex;">
                  <div style="width: 270px;">
                    <span class="card-header--title">Top Trending 4G Plans</span>
                  </div>
                  <div style="width: 35px;">
                    <img src=".\assets\images\plus.png" alt="" style="width: 16px;">
                  </div>
                </div>
              </ng-template>

              <ng-template ngbPanelContent>
                <div class="col-lg-12 row" style="margin: 0;padding: 0;">

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!-- !----!---! -->
          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>
                <div class="row " style="justify-content: space-between;width: 732px;display: flex;">
                  <div style="width: 270px;">
                    <span class="card-header--title"> Trending 5G Unlimited Plans</span>
                  </div>
                  <div style="width: 35px;">
                    <img src=".\assets\images\plus.png" alt="" style="width: 16px;">
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="col-lg-12 row" style="margin: 0;padding: 0;">


                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!-- !----!-----! -->

          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>
                <div class="row " style="justify-content: space-between;width: 732px;display: flex;">
                  <div style="width: 270px;">
                    <span class="card-header--title"> Trending 5G Unlimited Plans</span>
                  </div>
                  <div style="width: 35px;">
                    <img src=".\assets\images\plus.png" alt="" style="width: 16px;">
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="col-lg-12 row" style="margin: 0;padding: 0;">


                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!-- !-----!----! -->
          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>
                <div class="row " style="justify-content: space-between;width: 732px;display: flex;">
                  <div style="width: 270px;">
                    <span class="card-header--title"> Trending 5G Unlimited Plans</span>
                  </div>
                  <div style="width: 35px;">
                    <img src=".\assets\images\plus.png" alt="" style="width: 16px;">
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="col-lg-12 row" style="margin: 0;padding: 0;">


                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!-- !-----!----! -->
          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>

                <div class="row " style="justify-content: space-between;width: 732px;display: flex;">
                  <div style="width: 270px;">
                    <span class="card-header--title"> Trending 5G Unlimited Plans</span>
                  </div>
                  <div style="width: 35px;">
                    <img src=".\assets\images\plus.png" alt="" style="width: 16px;">
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="col-lg-12 row" style="margin: 0;padding: 0;">

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!-- !------!-----! -->
          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>
                <div class="row " style="justify-content: space-between;width: 732px;display: flex;">
                  <div style="width: 270px;">
                    <span class="card-header--title"> Trending 5G Unlimited Plans</span>
                  </div>
                  <div style="width: 35px;">
                    <img src=".\assets\images\plus.png" alt="" style="width: 16px;">
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="col-lg-12 row" style="margin: 0;padding: 0;">


                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!-- !------!---! -->
          <ngb-accordion #acc11="ngbAccordion">
            <ngb-panel id="toggle-11">
              <ng-template ngbPanelTitle>
                <div class="row " style="justify-content: space-between;width: 732px;display: flex;">
                  <div style="width: 270px;">
                    <span class="card-header--title"> Trending 5G Unlimited Plans</span>
                  </div>
                  <div style="width: 35px;">
                    <img src=".\assets\images\plus.png" alt="" style="width: 16px;">
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="col-lg-12 row" style="margin: 0;padding: 0;">


                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                  <div class="card col-4  mb-3"
                    style="border-radius: 20px;box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);background-color: #e7ebf8;"
                    id="hc">
                    <h1 class="text-dark fw-bold" style="padding-left: 10px;">₹100</h1>
                    <div class="row mt-2" style="padding-left: 10px;" id="hc">
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">90 Days</h2>
                        <h3 style="font-size: 18px;">Validity</h3>
                      </div>
                      <div style="width: 110px;">
                        <h2 class="text-dark" style="font-size: 18px;">5 GB</h2>
                        <h3 style="font-size: 18px;">Data</h3>
                      </div>
                    </div>
                    <div class="mb-3 text-center mt-1">
                      <button class="btn  text-white text-center"
                        style="padding: 10px 40px;border-radius: 20px;background-color: mediumslateblue;">BUY</button>
                    </div>
                  </div>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!-- !----!---! -->

        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>

  <!-- !---!----! -->


  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content18 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Plan Expired Date</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">

          <div class=" card-body table-responsive col-lg-12 "
            style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
            <table>
              <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
                <tr class="text-white text-center">
                  <td style="padding:10px">
                    <input type="checkbox">
                  </td>
                  <td style="padding:10px;">User ID</td>
                  <td style="padding:10px;">User Name</td>
                  <td style="padding:10px;">Date</td>
                </tr>
              </thead>
              <thead>
                <tr *ngFor="let i of uservalue">
                  <th style="padding: 10px 10px;">
                    <input type="checkbox">
                  </th>
                  <th style="padding: 10px 10px;">{{i.userid}}</th>
                  <th style="padding: 10px 10px;">
                    <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;" class="mx-1">{{i.username}}
                  </th>
                  <th style="padding: 10px 10px;">
                    <button class="btn  text-center fw-bold text-white"
                      style="background: linear-gradient(45deg, #A52A2A, #FF4500);border-radius: 35px;">{{i.expired}}</button>
                  </th>
                </tr>
              </thead>
            </table>
          </div>


        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>


  <!-- !----!Today Usages---! -->




  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content20 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Today Usages</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">

          <div class=" card-body table-responsive col-lg-12 "
            style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
            <table>
              <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
                <tr class="text-white text-center">
                  <td style="padding:10px">
                    <input type="checkbox">
                  </td>
                  <td style="padding:10px;">User ID</td>
                  <td style="padding:10px;">User Name</td>
                  <td style="padding:10px;">Usages</td>
                </tr>
              </thead>
              <thead>
                <tr *ngFor="let i of uservalue">
                  <th style="padding: 10px 10px;">
                    <input type="checkbox">
                  </th>
                  <th style="padding: 10px 10px;">{{i.userid}}</th>
                  <th style="padding: 10px 10px;">
                    <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;" class="mx-1">{{i.username}}
                  </th>
                  <th style="padding: 10px 10px;">
                    <button class="btn  text-center fw-bold text-white"
                      style="background: linear-gradient(45deg, #00ff00, #0080ff);border-radius: 35px;">{{i.data}}</button>
                  </th>
                </tr>
              </thead>
            </table>
          </div>


        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>


  <!-- !----!Balance -----! -->


  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content21 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Current Balance</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">

          <div class=" card-body table-responsive col-lg-12 "
            style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
            <table>
              <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
                <tr class="text-white text-center">
                  <td style="padding:10px">
                    <input type="checkbox">
                  </td>
                  <td style="padding:10px;">User ID</td>
                  <td style="padding:10px;">User Name</td>
                  <td style="padding:10px;">Balances</td>
                </tr>
              </thead>
              <thead>
                <tr *ngFor="let i of uservalue">
                  <th style="padding: 10px 10px;">
                    <input type="checkbox">
                  </th>
                  <th style="padding: 10px 10px;">{{i.userid}}</th>
                  <th style="padding: 10px 10px;">
                    <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;" class="mx-1">{{i.username}}
                  </th>
                  <th style="padding: 10px 10px;">
                    <button class="btn  text-center fw-bold text-white"
                      style="background: linear-gradient(45deg, #00ff00, #0080ff);border-radius: 35px;">{{i.plans}}</button>
                  </th>
                </tr>
              </thead>
            </table>
          </div>


        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>
  <!-- !----!----! -->

  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content25 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Total Days Plans</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">
          <div class=" card-body table-responsive col-lg-12  "
            style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;">
            <table>
              <thead style="background: linear-gradient(90deg, #0071bc, #33a1f2);">
                <tr class="text-white text-center">
                  <td style="padding:10px">
                    <input type="checkbox">
                  </td>
                  <td style="padding:10px;">User ID</td>
                  <td style="padding:10px;">User Name</td>
                  <td style="padding:10px;">Total Days</td>
                </tr>
              </thead>
              <thead>
                <tr *ngFor="let i of uservalue">
                  <th style="padding: 10px 10px;">
                    <input type="checkbox">
                  </th>
                  <th style="padding: 10px 10px;">{{i.userid}}</th>
                  <th style="padding: 10px 10px;">
                    <img src=".\assets\images\mainuser2.png" alt="" style="width: 20px;" class="mx-1"><span
                      class="mx-1">{{i.username}}</span>
                  </th>
                  <th style="padding: 10px 10px;">
                    <button class="btn  text-center fw-bold text-white"
                      style="background: linear-gradient(45deg, #00ff00, #0080ff);border-radius: 35px;">{{i.days}}</button>
                  </th>
                </tr>
              </thead>
            </table>
          </div>


        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>

  <!-- !----!---! -->
  <div class="card main-card" style="display: none;">
    <div class="card-body">
      <ng-template #content26 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">
          <div class="container ">
            <h3
              style="background: linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; "
              class="text-center">Subscriptions Plans</h3>
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>

        <div class="modal-body" style="background-color:ghostwhite;">

          <div class="col-lg-12 " id="mb">
            <div class="card-header" style="background: burlywood;border-radius: 8px;">
              <div>
                <h1 class="text  text-dark text-center " style="font-weight: 900;">Choose a data pack as per your needs
                </h1>
              </div>
            </div>
          </div>
          <!-- !---!--! -->
          <div class="scroll-area-lg">
            <perfect-scrollbar [autoPropagation]="true">


              <div class="col-lg-12  row mt-3" id="smc">


                <div class="col-lg-6 card  mb-3" id="ca">
                  <div class="header">
                    <h1 id="ph">1.5GB/Days</h1>
                    <h3>Unlimited calls and sims</h3>
                  </div>

                  <div class="card-body mt-3">

                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">India's best value
                        plan</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Surf on the internet,
                        enjoy social media shorts, or connect with friends online</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Talk to your loved ones
                        for hours with unlimited voice calls</span>
                    </div>

                    <button class="btn text-white fw-bold mt-1 " id="b" (click)="openLarge(content15)">Check
                      1.5GB/plans</button>
                  </div>
                </div>
                <!-- !----!---! -->
                <div class="col-lg-6 card  mb-3" id="ca">
                  <div class="header">
                    <h1 id="ph">1.5GB/Days</h1>
                    <h3>Unlimited calls and sims</h3>
                  </div>

                  <div class="card-body mt-3">

                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">India's best value
                        plan</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Surf on the internet,
                        enjoy social media shorts, or connect with friends online</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Talk to your loved ones
                        for hours with unlimited voice calls</span>
                    </div>

                    <button class="btn text-white fw-bold mt-1 " id="b">Check 1.5GB/plans</button>
                  </div>
                </div>
                <!-- !-----!----! -->
                <div class="col-lg-6 card  mb-3" id="ca">
                  <div class="header">
                    <h1 id="ph">1.5GB/Days</h1>
                    <h3>Unlimited calls and sims</h3>
                  </div>

                  <div class="card-body mt-3">

                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">India's best value
                        plan</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Surf on the internet,
                        enjoy social media shorts, or connect with friends online</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Talk to your loved ones
                        for hours with unlimited voice calls</span>
                    </div>

                    <button class="btn text-white fw-bold mt-1 " id="b">Check 1.5GB/plans</button>
                  </div>
                </div>
                <!-- !-----!---! -->
                <div class="col-lg-6 card  mb-3" id="ca">
                  <div class="header">
                    <h1 id="ph">1.5GB/Days</h1>
                    <h3>Unlimited calls and sims</h3>
                  </div>

                  <div class="card-body mt-3">

                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">India's best value
                        plan</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Surf on the internet,
                        enjoy social media shorts, or connect with friends online</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Talk to your loved ones
                        for hours with unlimited voice calls</span>
                    </div>

                    <button class="btn text-white fw-bold mt-1" id="b">Check 1.5GB/plans</button>
                  </div>
                </div>
                <!-- !-----!----! -->
                <div class="col-lg-6 card  mb-3" id="ca">
                  <div class="header">
                    <h1 id="ph">1.5GB/Days</h1>
                    <h3>Unlimited calls and sims</h3>
                  </div>

                  <div class="card-body mt-3">

                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">India's best value
                        plan</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Surf on the internet,
                        enjoy social media shorts, or connect with friends online</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Talk to your loved ones
                        for hours with unlimited voice calls</span>
                    </div>

                    <button class="btn text-white fw-bold mt-1 " id="b">Check 1.5GB/plans</button>
                  </div>
                </div>
                <!-- !----!----! -->
                <div class="col-lg-6 card  mb-3" id="ca">
                  <div class="header">
                    <h1 id="ph">1.5GB/Days</h1>
                    <h3>Unlimited calls and sims</h3>
                  </div>

                  <div class="card-body mt-3">

                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">India's best value
                        plan</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Surf on the internet,
                        enjoy social media shorts, or connect with friends online</span>
                    </div>
                    <div class="mb-2">
                      <img src=".\assets\images\tick.png" alt="" width="20px"> <span class="mx-2">Talk to your loved ones
                        for hours with unlimited voice calls</span>
                    </div>

                    <button class="btn text-white fw-bold mt-1 " id="b">Check 1.5GB/plans</button>
                  </div>
                </div>



                <!-- !----!---! -->

              </div>


            </perfect-scrollbar>
          </div>
          <!-- !---!body ends---! -->

        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>

  <!-- !----!----! -->
  <div class="card main-card " style="display: none; border-radius: 40px;">
    <div class="card-body">
      <ng-template #content27 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;">

          <button type="button" class="btn-close " (click)="c('Cross click')" style="border:none;">
          </button>
        </div>
        <div class="modal-body" style="background-color:ghostwhite;">
          <h1>welcome</h1>

        </div>
        <div class="modal-footer" style="background-color: ghostwhite;">
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4"
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);" (click)="c('Close click')">Close</button>

        </div>
      </ng-template>
    </div>
  </div>